<template>
    <div>
        <vxe-button  status="primary"  @click="fixRatio">修改</vxe-button>
        <vxe-table
            border
            show-overflow
            :data="tableData"
            :column-config="{resizable: true}"
            :edit-config="{trigger: 'click', mode: 'cell'}">
            <!--            <vxe-column type="seq" width="60"></vxe-column>-->

            <vxe-column field="id" title="ID" width="100" fixed="left" ></vxe-column>
            <vxe-column field="symbol" title="名称" width="100" ></vxe-column>
            <vxe-column field="nowLeverage" title="当前杠杆" width="150" :edit-render="{}" sortable>
                <template #edit="{ row }">
                    <vxe-input v-model="row.nowLeverage" type="text"></vxe-input>
                </template>
            </vxe-column>
            <vxe-column field="maxLeverage" title="最大杠杆" width="100"></vxe-column>
<!--            <vxe-column field="" title="修改" width="100">-->
<!--                <template #default="{ row }">-->
<!--                    <vxe-button  status="primary" size="mini" @click="fixRatio(row)">修改</vxe-button>-->
<!--                </template>-->
<!--            </vxe-column>-->
        </vxe-table>
    </div>
</template>

<script>
import axios from "axios";
import { VxeTableInstance } from 'vxe-table'
import XEUtils from 'xe-utils'
import { VXETable } from 'vxe-table'


export default {
  name: 'App',
    data(){
        return {
            tableData: [],
            fetchUri: 'http://47.111.111.209:9997/open/getFollowSymbolList',
            sendUri: 'http://47.111.111.209:9997/open/updateFollowSymbolLeverage'

        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        fixRatio(){
            // console.log(this.tableData)
            const data = {
                list: this.tableData
            }
            //
            axios.post(this.sendUri, data).then(res => {
                // if (res.data.msg === 'success'){
                    VXETable.modal.message({ content: '修改成功！', status: 'success' })
                // }else{
                //     VXETable.modal.message({ content: '修改失败，接口报错！', status: 'error' })
                // }
            })
        },
        fetchData(){
            axios.get(this.fetchUri).then(res => {
                console.log(res)
                this.tableData = res.data.data
            })
        },
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
